import { useRegisterSW } from "virtual:pwa-register/react";

import { hooks } from "@/services/api/hooks";
import { appVersion } from "@/config/env";
import { useBoundStore } from "@/app/store";
import { appVersionIsBigger } from "@/shared/utils/common";
import { useCallback, useEffect } from "react";
import { addToast, Button } from "@heroui/react";

export function useSW() {
  const isAuthenticated = useBoundStore((state) => state.user.isAuthenticated);
  const { data: appMetadata } = hooks.appMetadata.useAppMetadata();
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  const handleRefreshPage = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  useEffect(() => {
    if (needRefresh && !appVersionIsBigger(appMetadata?.update.requiredVersion, appVersion)) {
      addToast({
        title: "New version available",
        description: "Refresh to update the app.",
        timeout: Infinity,
        endContent: (
          <Button color="primary" size="sm" variant="flat" onPress={handleRefreshPage}>
            Refresh
          </Button>
        ),
      });
    }
  }, [appMetadata, isAuthenticated, needRefresh, handleRefreshPage, updateServiceWorker]);

  return null;
}
